module.exports = __webpack_public_path__ + "static/media/account-icon.0fccca0e.svg";